import AuthCallback from '../components/auth-callback/AuthCallback';
import AuxiliaryRouter from './auxiliary-router/AuxiliaryRouter';
import CartHeader from '../page-fragments/cart-menu/CartHeader';
import CartHeaderMobileContent from '../page-fragments/cart-menu/CartHeaderMobileContent';
import CartModal from '../components/cart-modal/CartModal';
import EquipmentSearchAutoSuggest from '../page-fragments/search-autosuggest/EquipmentSearchAutoSuggest';
import LocationBottomSheet from '../components/location-bottom-sheet/LocationBottomSheet';
import LocationModal from '../components/location-modal/LocationModal';
import LoginRedirect from '../page-fragments/login-redirect/LoginRedirect';
import MessageModal from '../components/message-modal/MessageModal';
import NavbarLocation from '../page-fragments/navbar-location-selector/NavbarLocation';
import PageLoader from './../components/page-overlay-loader/LoaderWithPageOverlay';
import renderer from './renderer';
import UserMenu from '../page-fragments/user-menu/UserMenu';
import UserMenuContent from '../page-fragments/user-menu/UserMenuContent';
import { useEffect } from 'react';
import {
  GenericRendererComponent,
  RendererComponentType,
  RendererComponentWithAuth,
  RendererSelectorType,
} from '../types/renderer';

const componentWithAuth: RendererComponentWithAuth = {
  componentType: RendererComponentType.AUTH,
  selectorType: RendererSelectorType.ID,
  selector: 'esr-auth-placeholder',
  component: () => {
    return <AuthCallback />;
  },
};

const componentsRegister: GenericRendererComponent[] = [
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-user-dropdown-menu',
    component: () => {
      return <UserMenu />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-mobile-user-menu-content',
    component: () => {
      return <UserMenuContent />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-mobile-cart-menu-content',
    component: () => {
      return <CartHeaderMobileContent />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-navbar-location-button',
    component: () => {
      return <NavbarLocation />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-cart-header-dropdown',
    component: () => {
      return <CartHeader />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.CLASS,
    selector: 'esr-cart-modal',
    component: () => {
      return <CartModal />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-location-modal',
    component: () => {
      return <LocationModal />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-location-bottomsheet',
    component: () => {
      return <LocationBottomSheet />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-page-overlay-loader',
    component: () => {
      return <PageLoader />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-message-modal',
    component: () => {
      return <MessageModal />;
    },
  },

  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.CLASS,
    selector: 'es-search-autosuggest',
    component: ({ id, show_close_button, toggle_width, is_mobile_nav_search_element }) => {
      return (
        id && (
          <EquipmentSearchAutoSuggest
            id={id}
            showCloseButton={show_close_button}
            toggleWidth={toggle_width}
            isMobileNavSearchElement={is_mobile_nav_search_element}
          />
        )
      );
    },
  },

  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-route-view',
    component: () => {
      return <AuxiliaryRouter />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-login-placeholder',
    component: () => {
      return <LoginRedirect />;
    },
  },
];

function Essentials() {
  useEffect(() => {
    renderer([componentWithAuth, ...componentsRegister]);
  }, []);

  return null;
}

export default Essentials;
